import SlideTemplate from "./SlideTemplate";

export default {
  /**
   *
   */
  mounted() {
    tippy('[data-tippy-content]', {
      placement: 'bottom'
    });
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    return (
      <SlideTemplate>
        <section class="p-6 lg:px-16 pt-4 flex flex-col justify-between">
          <div class="flex-1 flex flex-col justify-center">
            <p class="text-3xl lg:text-5xl font-bold text-brand-blue-600">
              Getting Started
            </p>

            <p class="lg:text-2xl leading-snug lg:leading-tight">
              In this simulation, you are leading the change management efforts for the implementation of a new
              facility-level quality improvement program. With the help of your team and advisory board, you earlier
              prepared for the change by identifying who and what needs to change, and creating some change stories to
              use during communication.
            </p>

            <div class="h-5"></div>

            <div class="lg:w-9/12">
              <div class="lg:text-2xl flex items-center justify-center">
                Facility A
                <div class="w-2 lg:w-3"></div>
                <div data-tippy-content="Met your goal of reaching at least 80% adoption" class="z-10">
                  <img src="/img/changemanagement/img-trophy-alt.svg" alt="" class="w-6 lg:w-8"/>
                </div>
              </div>
              <div class="relative">
                <small>Adoption</small>
                <span data-tippy-content="Implementation of the change at this location">
                  <i class="mdi mdi-help-circle text-brand-orange-700 text-sm lg:text-base"></i>
                </span>
                <div class="bg-brand-blue-400 rounded-full w-full overflow-hidden relative z-10 mt-1">
                  <div class="bg-brand-green-300 rounded-full p-1" style="width: 20%; box-shadow: 6px 0px 2px #00000029;">
                  </div>
                </div>
                <div class="absolute overflow-visible text-xs w-0 -ml-2 transform -translate-y-4" style="left: 20%;">
                  <div class="h-6 w-px bg-gray-900 mx-auto ml-2"></div>
                  20%
                </div>
              </div>
              <div class="h-6 lg:h-4"></div>
              <div class="relative">
                <small>Community</small>
                <span data-tippy-content="Active community participation in routine immunization planning">
                  <i class="mdi mdi-help-circle text-brand-orange-700 text-sm lg:text-base"></i>
                </span>
                <div class="bg-brand-blue-400 rounded-full w-full overflow-hidden relative z-10 mt-1">
                  <div class="bg-brand-green-300 rounded-full p-1" style="width: 20%; box-shadow: 6px 0px 2px #00000029;">
                  </div>
                </div>
                <div class="absolute overflow-visible text-xs w-0 -ml-2 transform -translate-y-4" style="left: 20%;">
                  <div class="h-6 w-px bg-gray-900 mx-auto ml-2"></div>
                  20%
                </div>
              </div>
            </div>

            <ul class="py-3 lg:py-5 flex flex-wrap justify-around lg:justify-start lg:w-10/12 my-6 lg:my-0 -mx-4 lg:mx-0">
              <li class="lg:w-1/3 my-2 lg:my-0 flex lg:items-center">
                <div class="flex flex-col items-center">
                  <img src="/img/changemanagement/img-EPI-focal-point@2x.png" alt="" class="w-16 lg:w-24 transform hover:scale-105"/>
                  <div class="text-xs text-center w-16 lg:w-auto">Epi Focal Point</div>
                </div>
                <ul class="text-xs pl-2 transform scale-90 lg:scale-100 translate-y-1 lg:translate-y-0">
                  <li>
                    <div class="transform origin-left scale-90">
                      <div class="bg-brand-gray-300 rounded-full p-px border-gray-300 border w-20 lg:w-24">
                        <div class="bg-brand-orange-500 rounded-full p-1" style="width: 20%">
                        </div>
                      </div>
                    </div>
                    <small class="px-2 py-px">
                      Motivation: 20%
                    </small>
                  </li>
                  <li>
                    <div class="transform origin-left scale-90">
                      <div class="bg-brand-gray-300 rounded-full p-px border-gray-300 border w-20 lg:w-24">
                        <div class="bg-brand-teal-500 rounded-full p-1" style="width: 80%">
                        </div>
                      </div>
                    </div>
                    <small class="px-2 py-px">
                      Abilities: 80%
                    </small>
                  </li>
                </ul>
              </li>
              <li class="lg:w-1/3 my-2 lg:my-0 flex lg:items-center">
                <div class="flex flex-col items-center relative">
                  <div class="absolute h-5 lg:h-6 w-5 lg:w-6 right-0 top-0 z-10 lg:m-1">
                    <div data-tippy-content="New content available">
                      <img src="/img/changemanagement/new-badge.svg" alt="NEW" class="w-full h-full"/>
                    </div>
                  </div>
                  <img src="/img/changemanagement/img-manager@2x.png" alt="" class="w-16 lg:w-24 transform hover:scale-105"/>
                  <div class="text-xs w-16 lg:w-auto text-center">Manager</div>
                </div>
                <div>
                  <ul class="text-xs pl-2 transform scale-90 lg:scale-100 translate-y-1 lg:translate-y-0">
                    <li>
                      <div class="transform origin-left scale-90">
                        <div class="bg-brand-gray-300 rounded-full p-px border-gray-300 border w-20 lg:w-24">
                          <div class="bg-brand-orange-500 rounded-full p-1" style="width: 60%">
                          </div>
                        </div>
                      </div>
                      <small class="px-2 py-px">
                        Motivation: 60%
                      </small>
                    </li>
                    <li>
                      <div class="transform origin-left scale-90">
                        <div class="bg-brand-gray-300 rounded-full p-px border-gray-300 border w-20 lg:w-24">
                          <div class="bg-brand-teal-500 rounded-full p-1" style="width: 40%">
                          </div>
                        </div>
                      </div>
                      <small class="px-2 py-px">
                        Abilities: 40%
                      </small>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="lg:w-1/3 my-2 lg:my-0 flex lg:items-center">
                <div class="flex flex-col items-center">
                  <img src="/img/changemanagement/img-vaccinator@2x.png" alt="" class="w-16 lg:w-24 transform hover:scale-105"/>
                  <div class="text-xs w-16 lg:w-auto text-center">
                    Vaccinator
                  </div>
                </div>
                <ul class="text-xs pl-2 transform scale-90 lg:scale-100 translate-y-1 lg:translate-y-0">
                  <li>
                    <div class="flex items-center">
                      <div class="transform origin-left scale-90">
                        <div class="bg-brand-gray-300 rounded-full p-px border-gray-300 border w-20 lg:w-24">
                          <div class="bg-brand-orange-500 rounded-full p-1" style="width: 60%">
                          </div>
                        </div>
                      </div>
                      <div class="leading-none" data-tippy-content="Willingness and enthusiasm to implement the change">
                        <i class="mdi mdi-help-circle text-brand-orange-700 text-sm lg:text-base"></i>
                      </div>
                    </div>
                    <small class="px-2 py-px">
                      Motivation: 60%
                    </small>
                  </li>
                  <li>
                    <div class="flex items-center">
                      <div class="transform origin-left scale-90">
                        <div class="bg-brand-gray-300 rounded-full p-px border-gray-300 border w-20 lg:w-24">
                          <div class="bg-brand-teal-500 rounded-full p-1" style="width: 80%">
                          </div>
                        </div>
                      </div>
                      <div class="leading-none" data-tippy-content="Knowledge, skills, and authority to effectively implement the change">
                        <i class="mdi mdi-help-circle text-brand-orange-700 text-sm lg:text-base"></i>
                      </div>
                    </div>
                    <small class="px-2 py-px">
                      Abilities: 80%
                    </small>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </section>
        <section class="p-6 lg:px-16 pt-0 flex flex-col justify-between">
          <div class="flex-1 flex flex-col justify-center">
            <p class="text-3xl lg:text-5xl font-bold text-brand-blue-600">
              The Task
            </p>

            <p class="lg:text-2xl leading-snug lg:leading-tight">
              Now, your task is to pilot the implementation of this change. You have 78 weeks to reach at least 80%
              adoption for each of four groups: one district team and three health facilities.
            </p>

            <p class="lg:text-2xl leading-snug lg:leading-tight mt-5">
              To reach your goal, you will need to build
              <span class="mx-1 border-b-2 border-dotted border-gray-800" data-tippy-content="Willingness and enthusiasm to implement the change">motivation</span>
              and <span class="border-b-2 border-dotted border-gray-800" data-tippy-content="Knowledge, skills, and authority to effectively implement the change">abilities</span> so that
              <span class="mx-1 whitespace-no-wrap border-b-2 border-dotted border-gray-800" data-tippy-content="Individuals and groups who have some form of interest in the change, either as targets of the change, managers, or others who will be impacted indirectly">change stakeholders</span> are ready to adopt the change.
            </p>

            <div class="flex flex-col lg:flex-row lg:justify-between lg:py-5">
              <ul class="lg:w-5/12 flex justify-around mt-10 mb-8 lg:my-0">
                <li class="flex items-center mr-6 lg:mr-3">
                  <div class="relative w-12 lg:w-20 xl:w-24 transform scale-110 mr-2 lg:mr-4">
                    <img src="/img/changemanagement/graph-circle-14.svg" alt="" class="w-full"/>
                    <div
                      class="absolute left-0 right-0 bottom-0 text-center text-xl lg:text-5xl bold transform translate-y-1/2 lg:leading-none"
                      style="top: -50%;">14
                    </div>
                  </div>
                  <div class="w-10 lg:w-20 text-xs lg:text-lg xl:text-xl leading-none">of 78 WEEKS</div>
                </li>
                <li class="flex items-center">
                  <div class="relative w-12 lg:w-20 xl:w-24 transform scale-110 mr-2 lg:mr-4">
                    <img src="/img/changemanagement/graph-circle%2080.svg" alt="" class="w-full"/>
                    <div
                      class="absolute left-0 right-0 bottom-0 text-center text-xl lg:text-5xl bold transform translate-y-1/2 lg:leading-none"
                      style="top: -50%;">80
                    </div>
                  </div>
                  <div class="w-10 lg:w-20 text-xs lg:text-lg xl:text-xl leading-none">Percent Adoption</div>
                </li>
              </ul>
              <ul class="lg:w-6/12 lg:ml-auto flex justify-around lg:justify-between">
                <li class="flex flex-col items-center text-center">
                  <img src="/img/changemanagement/img-EPI-focal-point@2x.png" alt="" class="w-12 lg:w-20 xl:w-24"/>
                  <div class="text-xs font-semibold">District Health <br/> Team</div>
                </li>
                <li class="flex flex-col items-center text-center">
                  <img src="/img/changemanagement/img-manager@2x.png" alt="" class="w-12 lg:w-20 xl:w-24"/>
                  <div class="text-xs font-semibold">Facility A</div>
                </li>
                <li class="flex flex-col items-center text-center">
                  <img src="/img/changemanagement/img-facility-b@2x.png" alt="" class="w-12 lg:w-20 xl:w-24"/>
                  <div class="text-xs font-semibold">Facility B</div>
                </li>
                <li class="flex flex-col items-center text-center">
                  <img src="/img/changemanagement/img-facility-b-1@2x.png" alt="" class="w-12 lg:w-20 xl:w-24"/>
                  <div class="text-xs font-semibold">Facility C</div>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section class="p-6 lg:px-16 pt-0 flex flex-col justify-center">
          <p class="text-3xl lg:text-5xl font-bold text-brand-blue-600">
            Simulation Steps
          </p>

          <p class="lg:text-2xl leading-tight">
            Use the menu at the top to navigate between views in the simulation
          </p>

          <div class="flex flex-col lg:flex-row lg:items-center mt-5">
            <button
              class="cursor-auto w-48 bg-brand-gray-500 rounded-full p-2 px-6 uppercase text-white text-xs lg:text-sm flex justify-center items-center white focus:outline-none">
              <img src="/img/changemanagement/icn-case-study.svg" alt="" class="w-4 lg:w-6 mr-1"/>
              case study
            </button>
            <p class="py-2 lg:py-0 lg:px-10 text-sm lg:text-base">
              Review the Initial Case.
            </p>
          </div>

          <div class="flex flex-col lg:flex-row lg:mt-3">
            <div class="flex flex-col items-center py-5 self-start">
              <button
                class="cursor-auto w-48 bg-brand-gray-500 rounded-full p-2 px-6 uppercase text-white text-xs lg:text-sm flex justify-center items-center white focus:outline-none">
                <img src="/img/changemanagement/icn-stakeholders.svg" alt="" class="w-4 lg:w-6 mr-1"/>
                stakeholders
              </button>

              <img src="/img/changemanagement/icn-double-arrow.svg" alt="" class="h-6 lg:h-12 my-2"/>

              <button
                class="cursor-auto w-48 bg-brand-gray-500 rounded-full p-2 px-6 uppercase text-white text-xs lg:text-sm flex justify-center items-center white focus:outline-none">
                <img src="/img/changemanagement/icn-take-action.svg" alt="" class="w-4 lg:w-6 mr-1"/>
                take action
              </button>
            </div>

            <div class="lg:px-5 flex flex-col lg:flex-row lg:items-start leading-tight">
              <div class="lg:w-6/12 lg:p-5">
                <p class="text-sm lg:text-base">
                  Go to the Stakeholder’s view, and review information about the change stakeholders at each location.
                  When you are ready to take a new action, return to the Actions view.
                </p>
                <p class="my-3 lg:my-5 text-sm lg:text-base">
                  Go to the Take Action view, and select an action. After you confirm the action, you will
                  automatically be brought back to the Stakeholder’s view, where you can review the results of your
                  choices.
                </p>
              </div>
              <div class="lg:w-5/12 border-t lg:border-t-0 lg:border-l border-brand-gray-800 pt-3 lg:p-5 ml-auto">
                <p class="text-sm lg:text-base">
                  Repeat steps 2 and 3 to complete the simulation. You can revisit the case study and resources at any
                  time. Certain actions may eventually unlock additional tabs used for planning and implementation.
                </p>
              </div>
            </div>
          </div>
        </section>
      </SlideTemplate>
    );
  }
}
